import { useEffect } from "react";
import { useSelector } from "react-redux";
import {
  currentCameraTrackObj,
  selectCurrentCameraTrackId,
} from "slices/devicesSlice";

const useAttachCameraTrack = (videoElement) => {
  const currentCameraTrackId = useSelector(selectCurrentCameraTrackId);

  useEffect(() => {
    var sourceElement = videoElement.current;
    if (sourceElement && currentCameraTrackObj) {
      sourceElement.srcObject = new MediaStream([currentCameraTrackObj]);
      window.efs_debug &&
        window.log("Source Element for useAttachCameraTrack is found");
    } else
      window.efs_debug &&
        window.log("Source Element for useAttachCameraTrack is Null");
    return () => {
      if (sourceElement?.srcObject) sourceElement.srcObject = null;
    };
  }, [currentCameraTrackId, videoElement]);
};

export default useAttachCameraTrack;
